import { api } from './client'

export const reviewsAPI = {
  getEntityReviews: (entityId, params = {}) =>
    api.get(`/entities/${entityId}/reviews`, { params }),
  createReview: (entityId, data) =>
    api.post(`/reviews/entities/${entityId}`, data),
  updateReview: (id, data) =>
    api.put(`/reviews/${id}`, data),
  deleteReview: (id) =>
    api.delete(`/reviews/${id}`),
  getUserReviews: (userId, params = {}) =>
    api.get(`/reviews/users/${userId}`, { params })
}
